import React from 'react';
import { withRouter } from 'react-router-dom';
import { PSP_SITE_NAME } from '../../utils/constants';
import FieldWrapper from './fields/FieldWrapper';
import useConsumerPopup from '../Popup/useConsumerPopup';
import PopupContainer from '../Popup/PopupContainer';
import { useAppName, useSitecoreApiKey } from '../../utils/sitecoreContext';
import { FieldErrorComponent, FormErrorComponent } from './fields/FormElement';
import ExtendedForm from './extension/ExtendedForm';
import customFieldFactory from './fields/customFieldFactory';
import { IGNORE_REDIRECT_FOR_FORM, formFetcher } from './extension/formExtensionHelper';

export const Form = ({ fields, history, sitecoreApiKey, gtmEventName, closePopup }) => (
  <ExtendedForm
    fieldWrapperComponent={FieldWrapper}
    form={fields}
    sitecoreApiHost=""
    sitecoreApiKey={sitecoreApiKey}
    fieldFactory={customFieldFactory}
    errorComponent={FormErrorComponent}
    fieldValidationErrorsComponent={FieldErrorComponent}
    formFetcher={formFetcher({ gtmEventName })}
    onRedirect={url => {
      // TODO: handle form success action for instance, show toast
      closePopup();
      if (url !== IGNORE_REDIRECT_FOR_FORM) {
        history.push(url);
      }
    }}
  />
);

const SitecoreForm = ({ fields, rendering, history }) => {
  const { isCurrentPopup, setPopupId } = useConsumerPopup(rendering);
  const sitecoreApiKey = useSitecoreApiKey();
  const appName = useAppName();
  let gtmEventName = 'submit-form';
  const closePopup = () => setPopupId(null);

  switch (appName) {
    case PSP_SITE_NAME:
      gtmEventName = 'psp_survey_submission';
      break;
    default:
      break;
  }

  return (
    <PopupContainer isOpen={isCurrentPopup()} onClose={closePopup} dataTestId="cy-popup-sitecore-form">
      <Form
        closePopup={closePopup}
        fields={fields}
        sitecoreApiKey={sitecoreApiKey}
        history={history}
        gtmEventName={gtmEventName}
      />
    </PopupContainer>
  );
};

export default withRouter(SitecoreForm);
